import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const useIsShoppingCartEmpty = () => {
  const { ShoppingCartV2 } = useSelector(
    (state: RootState) => state.shoppingCartV2
  );

  const isShoppingCartEmpty = !ShoppingCartV2?.products;

  return isShoppingCartEmpty;
};

export default useIsShoppingCartEmpty;
